//------- Courses

export const COURSE_INFO_DRAWER_ID = 'courseInfo'
export const COURSE_CLONE_DRAWER_ID = 'courseClone'
